import { render, staticRenderFns } from "./details-modal.vue?vue&type=template&id=16e31719&scoped=true&"
import script from "./details-modal.vue?vue&type=script&lang=js&"
export * from "./details-modal.vue?vue&type=script&lang=js&"
import style0 from "./details-modal.vue?vue&type=style&index=0&id=16e31719&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e31719",
  null
  
)

component.options.__file = "details-modal.vue"
export default component.exports